<div class="drop-down">
  <ng-content select="[trigger]"></ng-content>
  <div
    *ngIf="isActive"
    class="content"
    role="menu"
    [ngStyle]="{ top: coordinations.y + 'px', left: coordinations.x + 'px' }"
    #content
  >
    <ng-content select="[content]"></ng-content>
  </div>
</div>